exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog.notif-dialog{-webkit-box-shadow:none;box-shadow:none}@media (min-width:600px){.elementVisor2{border-top-left-radius:600px!important;border-bottom-left-radius:600px!important}}", ""]);

// exports
